import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const toastBodyFn = /* @__PURE__ */ createRecipe('toast-body', {}, [])

const toastBodyVariantMap = {}

const toastBodyVariantKeys = Object.keys(toastBodyVariantMap)

export const toastBody = /* @__PURE__ */ Object.assign(memo(toastBodyFn.recipeFn), {
  __recipe__: true,
  __name__: 'toastBody',
  __getCompoundVariantCss__: toastBodyFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: toastBodyVariantKeys,
  variantMap: toastBodyVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, toastBodyVariantKeys)
  },
  getVariantProps: toastBodyFn.getVariantProps,
})